/* eslint-disable */
import listing from "@/apollo/packages/services/listing.gql";

export const state = () => ({
  listing: null,
  is_loading: false
});

export const mutations = {
  /**
   * @description
   * @author Saurabh Jangra
   * @date 24 Apr 2024 | 06:00PM
   * @param {*} state
   * @param {*} value
   */
  setListing(state, value) {
    state.listing = value;
  },

  /**
   * @description
   * @author Saurabh Jangra
   * @date 24 Apr 2024 | 06:00PM
   * @param {*} state
   * @param {*} value
   */
  setLoading(state, value) {
    state.is_loading = value;
  }
};

export const actions = {
  /**
   * @description
   * @author Saurabh Jangra
   * @date 24 Apr 2024 | 06:00PM
   * @param {*} { commit }
   * @returns {*}
   */
  fetchListing({ commit }) {
    commit("setListing", []);
    commit("setLoading", true);
    return new Promise((resolve) => {
      this.$apolloClient
        .query({ query: listing })
        .then(({ data }) => {
          commit("setListing", data.pkgServices);
          resolve(data.pkgServices);
          commit("setLoading", false);
        })
        .catch(() => {
          commit("setLoading", false);
        });
    });
  }
};

export const getters = {
  listing: (state) => state.listing,
  is_loading: (state) => state.is_loading
};
